import { BINDING_OPERATIONS, BINDING_ORIGINS, BINDING_STATUSES, operationLabel, originMeta, statusMeta } from "@/lib/screenBindings";

const sel = "ml-mono text-xs px-2 py-1.5 border border-[var(--ml-border)] bg-[var(--ml-surface)]";

/** Iter 45 — filter bar for screen format bindings. Values live in the URL. */
export default function BindingFilters({ filters, onChange, onClear }) {
  const set = (k, v) => onChange({ [k]: v });
  const text = (key, placeholder, testid, width = "w-32") => (
    <input
      type="text"
      value={filters[key] || ""}
      onChange={(e) => set(key, e.target.value.toUpperCase())}
      placeholder={placeholder}
      data-testid={testid}
      className={`ml-mono text-xs ${width} px-2 py-1.5 border border-[var(--ml-border)] uppercase`}
    />
  );
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="sb-filters">
      <input
        type="text"
        value={filters.q || ""}
        onChange={(e) => set("q", e.target.value)}
        placeholder="Search program, display file, format, statement…"
        data-testid="sb-filter-q"
        className="ml-mono text-xs w-64 px-2 py-1.5 border border-[var(--ml-border)]"
      />
      {text("program_name", "Program", "sb-filter-program")}
      {text("display_file", "Display file", "sb-filter-display-file")}
      {text("record_format", "Record format", "sb-filter-record-format")}
      <select value={filters.operation || ""} onChange={(e) => set("operation", e.target.value)} className={sel} data-testid="sb-filter-operation">
        <option value="">All operations</option>
        {BINDING_OPERATIONS.map((o) => <option key={o} value={o}>{operationLabel(o)}</option>)}
      </select>
      <select value={filters.status || ""} onChange={(e) => set("status", e.target.value)} className={sel} data-testid="sb-filter-status">
        <option value="">All statuses</option>
        {BINDING_STATUSES.map((s) => <option key={s} value={s}>{statusMeta(s).label}</option>)}
      </select>
      <select value={filters.confidence || ""} onChange={(e) => set("confidence", e.target.value)} className={sel} data-testid="sb-filter-confidence">
        <option value="">All confidence</option>
        {["high", "medium", "low"].map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <select value={filters.origin || ""} onChange={(e) => set("origin", e.target.value)} className={sel} data-testid="sb-filter-origin">
        <option value="">All origins</option>
        {BINDING_ORIGINS.map((o) => <option key={o} value={o}>{originMeta(o).label}</option>)}
      </select>
      <label className="flex items-center gap-1 ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">
        <input type="checkbox" checked={filters.include_inactive === "true"} onChange={(e) => set("include_inactive", e.target.checked ? "true" : "")} data-testid="sb-filter-include-inactive" />
        inactive manual
      </label>
      <button type="button" onClick={onClear} className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-primary)] hover:underline" data-testid="sb-filter-clear">
        Clear
      </button>
    </div>
  );
}
